import { isInRange, roundDecimals } from "@project-rouge/rg-core";
import { MathUtils } from "three";
function calculateSpaceSize({ area, sizeX, sizeY, sizeZ }) {
	let x = sizeX[0];
	const y = sizeY[0];
	let z = sizeZ[0];
	if (!isInRange(roundDecimals(x * z), ...area)) {
		z = MathUtils.clamp(area[0] / x, ...sizeZ);
		if (!isInRange(roundDecimals(x * z), ...area)) x = MathUtils.clamp(area[0] / z, ...sizeX);
	}
	return [
		x,
		y,
		z
	];
}
export { calculateSpaceSize };

//# sourceMappingURL=index114.js.map